__turbopack_context__.v({
  "avatarContainer": "test-embed-modal-module__rYDlEa__avatarContainer",
  "embedCode": "test-embed-modal-module__rYDlEa__embedCode",
  "embedContainer": "test-embed-modal-module__rYDlEa__embedContainer",
  "modalContent": "test-embed-modal-module__rYDlEa__modalContent",
});
